import { CookiesHandler } from "../utilities/CookieHandler";
import { isSelectedTenant, logInOut } from "../stores";
import { navigate } from "svelte-navigator";
import { Helpers } from "../utilities/Helpers";
export class Requests {
    constructor() {
        this.currentToken = "";
        this.baseUrl = "";
        this.baseUrl = window.environmentConfig.url;
        let existingToken = CookiesHandler.getTokenFromCookie('token');
        if (existingToken) {
            this.currentToken = existingToken;
            logInOut.isToken.set(true);
            logInOut.token.set(existingToken);
        }
        else {
            logInOut.token.set("");
        }
    }
    async baseRequest(method, url, body) {
        let response = await fetch(this.baseUrl.concat(url), {
            method: method,
            headers: {
                "Content-type": "application/json",
                "X-Api-Key": this.currentToken
            },
            body: JSON.stringify(body)
        });
        if (response.status === 200) {
            return response;
        }
        else {
            console.log("response from base request error", response);
        }
    }
    /** Method to log in */
    async logIn(credentials) {
        let url = "api/login";
        let response = await this.baseRequest("POST", url, credentials);
        let jsonData = await response.json();
        if (jsonData.success) {
            this.currentToken = jsonData.data.token;
            CookiesHandler.createCookie(this.currentToken);
            logInOut.token.set(jsonData.data.token);
            logInOut.isToken.set(true);
            return true;
        }
        else {
            return false;
        }
    }
    /** Method to log out: delete token and delete token cookie
     * @return true when done
    */
    logOut() {
        logInOut.token.set("");
        logInOut.isToken.set(false);
        logInOut.user.set({ username: "", role: "" });
        CookiesHandler.deleteCookie('token');
        isSelectedTenant.set(false);
        navigate("/");
        return true;
    }
    async getMe() {
        let url = "api/me";
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Return the list of tenants*/
    //token must be passed (problem with time in App.svelte)
    async getTenants() {
        let response = await this.baseRequest("GET", "api/tenants");
        // if(response.status === 200){
        //     let json = await response.json();
        //     let data: [] = json.data.filter((x: Tenant) => x.id !== null);
        //     Helpers.sortAsc(data, "name");
        //     return data;
        // }else{
        //     throw{
        //         errorCode: response.status,
        //         errorMessage: response.statusText
        //     }
        // }
        let json = await response.json();
        if (json.success) {
            let data = json.data.filter((x) => x.id !== null);
            Helpers.sortAsc(data, "name");
            return data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Return the tenant's users
     * @param tenantId string
     * @return users (Users[])
     */
    async getUsers(tenantId, offset, size, query) {
        let params = "?";
        if (offset) {
            params = params + 'offset=' + offset;
        }
        if (offset && size) {
            params = params + '&size=' + size;
        }
        else if (size) {
            params = params + 'size=' + size;
        }
        if ((offset || size) && query) {
            params = params + '&query=' + query;
        }
        else if (query) {
            params = params + 'query=' + query;
        }
        let url = `api/tenants/${tenantId}/users${params}`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            let res = json.data.map(x => {
                x['id'] = x.uuid;
                delete x.uuid;
                return x;
            });
            return res;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get user from his id
     * @param tenantId string
     * @param userId string
     * @return user
    */
    async getUser(tenantId, userId) {
        let url = `api/tenants/${tenantId}/users/${userId}`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get user's bookings
     * @param tenantId string
     * @param userId string
     * @return a list of bookigs Booking[]
     */
    async getUserBookings(tenantId, userId, until, offset, size) {
        let params = "?";
        if (until) {
            params = params.concat("until=" + until);
        }
        if (offset) {
            if (until) {
                params = params.concat("&");
            }
            params = params.concat("offset=" + offset.toString());
        }
        if (size) {
            if (offset || until) {
                params = params.concat("&");
            }
            params = params.concat("size=" + size.toString());
        }
        let url = `api/tenants/${tenantId}/users/${userId}/bookings${params}`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get user's presences
     * @param tenantId string
     * @param userId string
     * @return a list of bookigs Presence[]
     */
    async getUserPresences(tenantId, userId) {
        let url = `api/tenants/${tenantId}/users/${userId}/presence`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get the tenant's buildings
     * @param tenantId
     * @return Building[]
    */
    async getBuildings(tenantId) {
        let url = `api/tenants/${tenantId}/buildings`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get building's bookings
     * @param tenantId string
     * @param buildingId string
     * @return a list of bookigs Booking[]
     */
    async getBuildingBookings(tenantId, buildingId, until, offset, size, query) {
        let params = "?";
        if (until) {
            params = params.concat("until=" + until);
        }
        if (offset) {
            if (until) {
                params = params.concat("&");
            }
            params = params.concat("offset=" + offset.toString());
        }
        if (size) {
            if (offset || until) {
                params = params.concat("&");
            }
            params = params.concat("size=" + size.toString());
        }
        if (query) {
            if (offset || until || size) {
                params = params.concat("&");
            }
            params = params.concat("query=" + query);
        }
        let url = `api/tenants/${tenantId}/buildings/${buildingId}/bookings${params}`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get building's invitations
     * @param tenantId string
     * @param buildingId string
     * @return a list of invitations Invitation[]
     */
    async getBuildingInvitations(tenantId, buildingId, until, offset, size, query) {
        let params = "?";
        if (until) {
            params = params.concat("until=" + until);
        }
        if (offset) {
            if (until) {
                params = params.concat("&");
            }
            params = params.concat("offset=" + offset.toString());
        }
        if (size) {
            if (offset || until) {
                params = params.concat("&");
            }
            params = params.concat("size=" + size.toString());
        }
        if (query) {
            if (offset || until || size) {
                params = params.concat("&");
            }
            params = params.concat("query=" + query);
        }
        let url = `api/tenants/${tenantId}/buildings/${buildingId}/invitations${params}`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        console.log(json);
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get building's checkins
    * @param tenantId string
    * @param buildingId string
    * @return a list of checkins Checkin[]
    */
    async getBuildingCheckins(tenantId, buildingId, query) {
        let url = `api/tenants/${tenantId}/buildings/${buildingId}/checkins`;
        if (query) {
            url = url.concat("?query=" + query);
        }
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to get building's presences
     * @param tenantId string
     * @param buildingId string
     * @return a list of bookigs Presence[]
     */
    async getBuildingPresences(tenantId, buildingId) {
        let url = `api/tenants/${tenantId}/buildings/${buildingId}/presence`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to check gates and their status */
    async getGates(tenantId, buildingId) {
        let url = `api/tenants/${tenantId}/buildings/${buildingId}/gates`;
        let response = await this.baseRequest("GET", url);
        let json = await response.json();
        if (json.success) {
            return json.data;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
    /** Method to check the global health
     *
     */
    async getHealth() {
        let response = await this.baseRequest("GET", "health");
        if (response.status === 200) {
            let json = await response.json();
            return json;
        }
        else {
            throw {
                errorCode: response.status,
                errorMessage: response.statusText
            };
        }
    }
}
